module.exports = __webpack_public_path__ + "media/images/pic/truck-248cb33f824b344b36a70fd27fbaadc6.jpg";